import { libelleDernierAppel } from '../format';

export function IconeTelephone() {
  return (
    <svg className="icone-telephone" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1z"
      />
    </svg>
  );
}

/**
 * Dernier appel d'une candidature : icône et heure, rien si jamais appelée
 * (liste), ou « Jamais appelé » quand `siAucun` le demande (fiche).
 */
export function DernierAppel({
  le,
  joignable,
  siAucun,
}: {
  le: string | null;
  joignable: boolean | null;
  siAucun?: string;
}) {
  if (!le) return siAucun ? <span className="dernier-appel aucun">{siAucun}</span> : null;
  return (
    <span className="dernier-appel" title={new Date(le).toLocaleString('fr-FR')}>
      <IconeTelephone />
      {libelleDernierAppel(le, joignable)}
    </span>
  );
}
